import { Severity, type UUID } from '@cobliteam/common-types';

import { SettingsType } from '../dashboard/userAlert/commons';
import type { RoadSpeedLimitSettings, SettingsJson, StopIdleTimeSettings, UserAlertSettings, VehicleSpeedLimitSettings } from '../dashboard/userAlert/settings/definitions';

// todo: find out how this builder works in prod

export class UserAlertSettingsBuilder {
  private id?: UUID;

  private type: SettingsType;

  private active: boolean;

  private settingsJson: SettingsJson;

  private randomSeverity = () => Severity.MEDIUM;

  private randomRoadSpeedLimitSettings = (): RoadSpeedLimitSettings => ({
    durationAboveLimitInMillis: 60000,
    severity: this.randomSeverity(),
    vehicleGroupIds: [],
  });

  private randomVehicleSpeedLimitSettings = (): VehicleSpeedLimitSettings => ({
    durationAboveLimitInMillis: 60000,
    vehicleGroupIds: [],
  });

  private randomStopIdleTimeSettings = (): StopIdleTimeSettings => ({
    durationIdleInMillis: 60000,
    vehicleGroupIds: [],
  });

  private randomSettingsJson = (type: SettingsType) => {
    const settings = {
      [SettingsType.ROAD_SPEED_LIMIT]: this.randomRoadSpeedLimitSettings(),
      [SettingsType.VEHICLE_SPEED_LIMIT]: this.randomVehicleSpeedLimitSettings(),
      [SettingsType.STOP_IDLE_TIME]: this.randomStopIdleTimeSettings(),
    };

    return settings[type];
  };

  constructor() {
    this.id = undefined;
    this.type = SettingsType.ROAD_SPEED_LIMIT;
    this.active = false;
    this.settingsJson = this.randomSettingsJson(this.type);
  }

  public withId(id?: UUID): UserAlertSettingsBuilder {
    this.id = id;
    return this;
  }

  public withType(type: SettingsType): UserAlertSettingsBuilder {
    this.type = type;
    return this;
  }

  public withActive(active: boolean): UserAlertSettingsBuilder {
    this.active = active;
    return this;
  }

  public withSettingsJson(settingsJson: SettingsJson): UserAlertSettingsBuilder {
    this.settingsJson = settingsJson;
    return this;
  }

  public build = (): UserAlertSettings => ({
    id: this.id,
    type: this.type,
    active: this.active,
    settingsJson: this.settingsJson,
  });
}

export default UserAlertSettingsBuilder;
